import React from 'react'
import CIcon from '@coreui/icons-react'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'
import jwt_decode from "jwt-decode";
import { MyService, MyLine, CallList, TrasactionList, Colleagues, RequestSupport, MyDashboard, SettingQueueSVG, HeadPhoneSVG, SecretarySVG, FaxSVG, ContactsSvg, HomeSVG, NotebookSVG, FileChartSVG, VoiceMailSVG, UsersSVG, MdiCogSVG, TicketingSVG, ContactSVG } from './components/IconSvg'
import {
  cilBell,
  cilCalculator,
  cilChartPie,
  cilCursor,
  cilDescription,
  cilDrop,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilStar,
} from '@coreui/icons'


export const allLinks = {


}

// const actionsAccess = [
//   'viewProfile',
//   'viewTeamMember',
//   'viewDomains',
//   'viewCallReport',
//   'viewAllUsers',
//   'viewAccessibility',
//   'viewPackages',
//   'viewTransactions',
//   'manageProfile',
//   'manageTeamMember',
//   'manageDomains',
//   'manageCallReport',
//   'manageUsers',
//   'manageAccessibility',
//   'manageTeamMembers',
//   'managePackages',
//   'manageTransactions',



// ]



const _nav = [

  {
    component: CNavItem,
    name: 'MENU.DASHBOARD',
    text: 'Dashboard',
    to: '/dashboard',
    icon: <MyDashboard width={35} height={35} />


    // icon:'./images/Frame115.svg'
  },
  {
    component: CNavItem,
    name: 'MENU.MYSERVICE',
    text: 'Service',
    to: '/service',
    icon: <MyService width={35} height={35} />
  },
  {
    component: CNavItem,
    name: 'MENU.MYLINE',
    text: 'MyLine',
    // to: '/numberPage',
    to: '/numbers',
    icon: <MyLine width={35} height={35} />,
  },
  {
    component: CNavItem,
    name: 'MENU.FAX',
    text: 'fax',
    // to: '/numberPage',
    to: '/fax',
    icon: <FaxSVG width={24} height={24} fill={'#455A64'} />,
  },
  {
    component: CNavItem,
    name: 'MENU.LISTCALL',
    text: 'LISTCALL',
    to: '/callReport',
    icon: <CallList width={35} height={35} />
  },
  {
    component: CNavItem,
    name: 'MENU.MESSAGESECRETARY',
    text: 'MESSAGE',
    to: '/message/secretaryMessage',
    icon: <SecretarySVG fill={'#455A64'} width={18} height={18} />
  },
  // {
  //   component: CNavItem,
  //   name: 'MENU.MESSAGESECRETARY',
  //   text: 'MESSAGESECRETARY',
  //   to: '/message/secretaryMessage',
  //   icon: <HeadPhoneSVG width={35} height={35} />
  // },

  {
    component: CNavItem,
    name: 'MENU.LISTTRANSACTION',
    text: 'ListTransaction',
    to: '/transactions',
    icon: <TrasactionList width={35} height={35} />
  },
  {
    component: CNavItem,
    name: 'MENU.VOICEMAIL',
    text: 'mailVoice',
    to: '/voiceMails',
    icon: <Colleagues width={35} height={35} />
  },

  {
    component: CNavItem,
    name: 'MENU.SUPPORT',
    text: 'support',
    to: '/tickets',
    icon: <Colleagues width={35} height={35} />
  },

  {
    component: CNavItem,
    name: 'MENU.COLLEAGUES',
    text: 'colleagues',
    to: '/customerMember/members',
    icon: <Colleagues width={35} height={35} />
  },
  {
    component: CNavItem,
    name: 'MENU.REQUESTSUPPORT',
    text: 'RequestSupport',
    to: '/requestsupport',
    icon: <RequestSupport width={35} height={35} />
  },
  {
    component: CNavItem,
    name: 'MENU.SETTING',
    text: 'RequestSupport',
    icon: <SettingQueueSVG width={25} height={25} />,
    items: [{
      component: CNavItem,
      name: 'صف',
      text: 'queue',
      // to: '/queueList',

    }, 
    // {
    //   component: CNavItem,
    //   name: 'هوک',
    //   text: 'hook',
    //   to: '/hook',

    // },
  ]
  },
  {
    component: CNavItem,
    name: 'MENU.CALENDAR',
    text: 'Calendar',
    to: '/calendar',
    icon: <SettingQueueSVG width={25} height={25} />
  },
  {
    component: CNavItem,
    name: 'MENU.CONTACTS',
    text: 'contacts',
    to: '/contacts/contact',
    icon: <ContactsSvg width={25} height={25} />
  },

]




export default _nav



export const links = (t) => {


  return [
    {

      name: t('MENU.DASHBOARD'),
      to: '/dashboard',
      style: { paddingLeft: '5px', paddingRight: '10px' },
      icon: <HomeSVG width={24} height={24} fill={'#455A64'} />,
      show: false,
      items: []

    },
    {

      name: t('MENU.MYLINE'),
      to: '/numbers',
      style: { paddingLeft: '5px', paddingRight: '10px' },
      icon: <NotebookSVG width={24} height={24} fill={'#455A64'} />,
      show: false,
      items: []

    },
    {

      name: "گزارش‌ها",
      to: "#",
      style: { paddingLeft: '5px', paddingRight: '33px' },
      icon: <FileChartSVG width={24} height={24} fill={'#455A64'} />,
      show: false,

      items: [
        {

          name: "تماس‌ها",
          to: '/callReport',
          style: {},

        },
        {

          name: "صف",
          to: '/queueList/queueFunctions',
          style: {},

        },
        {

          name: "منشی",
          to: '/message/secretaryMessage',
          style: {},

        },

        {

          name: "نظرسنجی",
          to: '/callRatingReport',
          style: {},

        },
      ]
    },

    {

      name: "فکس اینترنتی",
      to: '/fax',
      style: { paddingLeft: '5px', paddingRight: '10px' },
      icon: <FaxSVG width={24} height={24} fill={'#455A64'} />,
      show: false,
      items: []

    },
    {

      name: "صندوق صوتی",
      to: "/voiceMails",
      style: { paddingLeft: '5px', paddingRight: '10px' },
      icon: <VoiceMailSVG width={24} height={24} fill={'#455A64'} />,
      show: false,
      items: []

    },
    {

      name: t('MENU.COLLEAGUES'),
      to: "#",
      style: {},
      icon: <UsersSVG width={24} height={24} fill={'#455A64'} />,
      show: false,
      items: [{

        name: "لیست همکاران",
        to: "/customerMember/members",
        style: {},

      }, {

        name: "مدیریت اعلان‌ها",
        to: "/customerMember/notification",
        style: {},

      }]

    },
    {

      name: "تنظیمات",
      to: "#",
      style: {},
      icon: <MdiCogSVG width={24} height={24} fill={'#455A64'} />,
      show: false,

      items: [
        {

          name: "صف",
          to: "/queueList",
          style: {},

        },
        //  {

        //   name: "اتصال به سامانه پیامکی",
        //   to: "/smsConnectionSettings",
        //   style: {},

        // }
        // {

        //   name: "هوک",
        //   to: '',
        //   style: {},

        // },
      ]
    },
    {

      name: t('MENU.REQUESTSUPPORT'),
      to: "/tickets",
      style: {},
      icon: <TicketingSVG width={24} height={24} fill={'#455A64'} />,
      show: false,
      items: []

    },
    {

      name: "دفترچه",
      to: '/contacts/contact',
      style: {},
      icon: <ContactSVG width={24} height={24} fill={'#455A64'} />,
      show: false,
      items: []

    },
  ]
}